
import { Component, OnInit } from '@angular/core';
  import { FormBuilder, FormGroup, Validators } from '@angular/forms';
  import { ActivatedRoute, Router } from '@angular/router';

import { ApiService } from '../shared/services/api.service';
@Component({
  selector: 'app-onboarding',
  templateUrl: './onboarding.component.html',
  styleUrl: './onboarding.component.css'
})
export class OnboardingComponent implements OnInit {
    orgForm!: FormGroup;
    emailForm!: FormGroup;
    emailVerified = false;
    editMode = false;
    orgId: string | null = null;
  
    constructor(
      private fb: FormBuilder,
      private router: Router,
      private route: ActivatedRoute,
      private apiService: ApiService
    ) {}
  
    ngOnInit(): void {
      this.initForms();
      this.orgId = this.route.snapshot.paramMap.get('id');
      if (this.orgId) {
        this.editMode = true;
        this.loadOrganization(this.orgId);
        this.emailVerified = true; // skip email check in edit mode
      }
    }
  
    initForms(): void {
      this.emailForm = this.fb.group({
        email: ['', [Validators.required, Validators.email]]
      });
  
    }
  
    verifyEmail(): void {
      if (this.emailForm.invalid) return;
      const email = this.emailForm.value.email;
      // Simulate API email verification
      this.emailVerified = true;
      this.orgForm.patchValue({
        primary_contact_email: email,
        primaryContact: {
          email: email
        }
      });
    }
  
    loadOrganization(id: string): void {
      this.apiService.getOrganizationById(id).subscribe((data:any) => {
        this.orgForm.patchValue(data);
      });
    }
  

  headerLogo = '../../assets/image/logo.png';
  supportContactEmail = 'support@sigmat.in';
  supportContactNumber = '+91 8878857588';

  get supportPhoneHref(): string {
    return 'tel:' + this.supportContactNumber.replace(/\s+/g, '');
  }

  get isCompactAuthCard(): boolean {
    return this.router.url.includes('verify-email');
  }

  loadCalendly(): void {
    window.open('https://calendly.com/awasrishabh/30min', '_blank', 'noopener');
  }
 
  
}
